import {
    RequestConfigFunction,
} from 'app/types/request.types'

type HsCodeRequests = {
    domainName: string,
    filterAllRequest: RequestConfigFunction<Record<string, any>>,
    get: RequestConfigFunction<{id: number}>,
    update: RequestConfigFunction<{id: number}>,
}

const hsCodeRequests: HsCodeRequests = {
    domainName: 'harmonizedsystemcode',
    filterAllRequest: ({
        params,
    }) => {
        return {
            url: 'harmonizedsystemcode/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `harmonizedsystemcode/${id}`,
            method: 'GET',
        }
    },
    update: ({
        id,
    }) => {
        return {
            url: `harmonizedsystemcode/${id}`,
            method: 'PATCH',
        }
    },
}

export default hsCodeRequests
